import React from 'react'
import { css } from 'emotion'
import { CFImage, CFView, PrimaryModal } from 'components'
import {
  specialButton,
  special,
  lunchButton,
  lunch,
  mainMenu,
  mainButton,
  drinkMenu,
  drinkButton,
  happyMenu,
  happyButton,
} from 'images'

export default props => {
  return (
    <PrimaryModal
      title={'Choose Menu'}
      isOpen={props.showModal}
      onRequestClose={props.onRequestClose}
    >
      <CFView className={styles.container}>
        <CFView column alignCenter w="100%">
          <a target="_blank" href={special}>
            <CFView hover>
              <CFImage
                maxWidth="270px"
                src={specialButton}
                alt="Skip the Dishes"
              />
            </CFView>
          </a>
          <a target="_blank" href={lunch}>
            <CFView hover mt="15px">
              <CFImage
                maxWidth="270px"
                src={lunchButton}
                alt="Skip the Dishes"
              />
            </CFView>
          </a>
          <a target="_blank" href={mainMenu}>
            <CFView hover mt="15px">
              <CFImage maxWidth="270px" src={mainButton} alt="Door Dash" />
            </CFView>
          </a>
          <a target="_blank" href={drinkMenu}>
            <CFView hover mt="15px">
              <CFImage maxWidth="270px" src={drinkButton} alt="Door Dash" />
            </CFView>
          </a>
          <a target="_blank" href={happyMenu}>
            <CFView hover mt="15px">
              <CFImage maxWidth="270px" src={happyButton} alt="Door Dash" />
            </CFView>
          </a>
        </CFView>
      </CFView>
    </PrimaryModal>
  )
}

const styles = {
  container: css({
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '400px',
    '@media (max-width: 767px)': {
      padding: '30px',
      width: '330px',
    },
  }),
}
